import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ReactTooltip from 'react-tooltip'
import { Badge, SvgComponent } from '@platform/ui'
import cn from 'classnames'
import styles from './DraftActivity.module.scss'

export const DraftActivity = () => {
  const { t, i18n } = useTranslation()
  const [isDraftToolTipMounted, setIsDraftToolTipMounted] = useState<boolean>(false)

  const isRTL = i18n.dir() === 'rtl'

  return (
    <div
      className={styles.draftActivity}
      onMouseEnter={() => setIsDraftToolTipMounted(true)}
      onMouseLeave={() => setIsDraftToolTipMounted(false)}
      data-tip={t('comingSoon')}
    >
      <Badge color="neutral">
        <SvgComponent name="TimeBoldStroke" size="sm" />
      </Badge>

      <div className={cn(styles.tooltipWrapper, { [styles.tooltipVisible]: isDraftToolTipMounted })}>
        <ReactTooltip
          className={styles.tooltip}
          effect="solid"
          place={isRTL ? 'left' : 'right'}
          offset={{ bottom: 0, ...(isRTL ? { right: 0 } : { left: 0 }) }}
        />
      </div>
    </div>
  )
}
